import React from 'react';
import _ from '@lodash';

function useDebounce(func: (...props: any) => void, wait: number, options?: any) {
	return React.useRef(_.debounce(func, wait, options)).current;
}

export default useDebounce;
